import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { companyService } from '../../services/companyService';
import { authService } from '../../services/authService';
import CompanyNav from '../../components/CompanyNav';
import CompanyBottomNavigation from '../../components/CompanyBottomNavigation';
import Loader from '../../components/Loader';
import { useNavigate } from 'react-router-dom';

const Plans = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [subscribingPlanId, setSubscribingPlanId] = useState(null);
  const user = authService.getCurrentUser();
  const isEmployeeRole = (user?.user_company_role || user?.company_role || user?.roleInCompany) === 'employee';
  const navigate = useNavigate();

  const fetchPlans = async () => {
    try {
      setLoading(true);
      const data = await companyService.getPlans();
      setPlans(Array.isArray(data?.data) ? data.data : data);
    } catch (error) {
      toast.error('Failed to load plans');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isEmployeeRole) {
      navigate('/company/vacancies', { replace: true });
      return;
    }
    fetchPlans();
  }, []);

  const handleSubscribe = async (planId) => {
    try {
      setSubscribingPlanId(planId);
      await companyService.subscribe(planId);
      toast.success('تم الاشتراك بنجاح');
    } catch (error) {
      const message = error?.response?.data?.message || 'فشل الاشتراك';
      toast.error(message);
    } finally {
      setSubscribingPlanId(null);
    }
  };

  if (loading) {
    return <Loader fullScreen={true} size="large" />;
  }

  return (
    <div className="employee-home-page" dir="rtl">
      <CompanyNav user={user} />

      {/* Header */}
      <div className="px-3 mb-4 mt-3">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h3 className="section-title mb-1">باقات الاشتراك</h3>
            <p className="text-muted mb-0" style={{ fontSize: '0.9rem' }}>اختر الباقة المناسبة لشركتك</p>
          </div>
        </div>
      </div>

      {/* Plans */}
      <div className="all-jobs-section px-3 mb-5">
        {(!plans || plans.length === 0) ? (
          <div className="text-center py-5">
            <p className="empty-state-text mb-3">لا توجد باقات متاحة حالياً</p>
          </div>
        ) : (
          <div className="jobs-list">
            {plans.map((plan) => (
              <div key={plan.id} className="job-card mb-3">
                <div className="d-flex align-items-start gap-3">
                  <div className="company-logo-card">
                    <div className="company-logo-text text-dark align-content-center">
                      <b>{plan?.name?.charAt(0)?.toUpperCase() || 'P'}</b>
                    </div>
                  </div>
                  <div className="job-content flex-grow-1">
                    <div className="d-flex justify-content-between align-items-start mb-2">
                      <div className="flex-grow-1">
                        <div className="job-title-card mb-1">
                          {plan.name || 'الباقة'}
                        </div>
                        <div className="job-company-location mb-2">
                          {typeof plan.price === 'number' ? `${plan.price.toFixed(2)} $` : (plan.price ?? '—')}
                        </div>
                        <div className="job-tags d-flex gap-2 mb-2 flex-wrap">
                          {'duration_days' in plan && (
                            <span className="status-badge-success">المدة: {plan.duration_days} يوم</span>
                          )}
                          <br />
                          {'vacancies_limit' in plan && (
                            <span className="status-badge-info">عدد الوظائف: {plan.vacancies_limit ?? 'غير محدود'}</span>
                          )}
                          <br />
                          {'users_limit' in plan && (
                            <span className="status-badge-warning">المستخدمون: {plan.users_limit ?? 'غير محدود'}</span>
                          )}
                        </div>
                        {plan.description && (
                          <div
                            className="text-muted"
                            style={{ fontSize: '0.9rem' }}
                            dangerouslySetInnerHTML={{ __html: plan.description }}
                          />
                        )}
                      </div>
                    </div>
                    <div className="d-flex gap-2 flex-wrap">
                      <button
                        onClick={() => handleSubscribe(plan.id)}
                        className="btn-apply"
                        style={{
                          background: 'linear-gradient(135deg, #608fd3 0%, #4a7bc4 100%)',
                          color: 'white'
                        }}
                        disabled={!!subscribingPlanId}
                      >
                        {subscribingPlanId === plan.id ? 'جارٍ الاشتراك...' : 'اشترك الآن'}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <CompanyBottomNavigation />
    </div>
  );
};

export default Plans;


